import { render, staticRenderFns } from "./BrandCatalog.vue?vue&type=template&id=7b321caa&lang=pug"
import script from "./BrandCatalog.vue?vue&type=script&lang=js"
export * from "./BrandCatalog.vue?vue&type=script&lang=js"
import style0 from "./BrandCatalog.vue?vue&type=style&index=0&id=7b321caa&prod&lang=sass"
import style1 from "./BrandCatalog.vue?vue&type=style&index=1&id=7b321caa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports